// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"mywork_fieldset__18mEM","legend":"mywork_legend__2yw1t","content":"mywork_content__QmcCr"};